import Constants from "expo-constants";
import { Platform } from "react-native";

const getHost = () => {
  const host = Constants.expoConfig?.hostUri?.split(":").shift();
  if (host) return host;
  return Platform.select({
    ios: "localhost",
    android: "10.0.2.2",
    default: "localhost",
  });
};

const apiHost = Constants.expoConfig?.extra?.apiUrl || "backend.montu.io";

// In development the backend is normally proxied onto port 80, so the host alone is
// the whole origin. Set EXPO_PUBLIC_DEV_BACKEND to "localhost:8001" (or any host:port)
// to talk to a backend running without that proxy.
const devHost = process.env.EXPO_PUBLIC_DEV_BACKEND || getHost();

const getUrl = () => {
  const nodeEnv = process.env.NODE_ENV;
  if (nodeEnv === "development") {
    return `http://${devHost}`;
  }
  return `https://${apiHost}`;
};
const getWebSocketUrl = () => {
  const nodeEnv = process.env.NODE_ENV;
  if (nodeEnv === "development") {
    return `ws://${devHost}`;
  }
  return `wss://${apiHost}`;
};
const backendUrl = getUrl();
const webSocketUrl = getWebSocketUrl();

export { backendUrl, webSocketUrl };
